module.exports = __webpack_public_path__ + "img/shape-metal_ag-mobile-gold@2x.49798889.png";